import React, { useState, useEffect } from 'react';
import { Container, TextField, Button, Typography, Box, CircularProgress, Link } from '@mui/material';
import { forgotPassword, generateCaptcha } from '../services/api';
import { Link as RouterLink } from 'react-router-dom';  // 引入 RouterLink

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [captchaId, setCaptchaId] = useState('');
  const [captchaValue, setCaptchaValue] = useState('');
  const [captchaImage, setCaptchaImage] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    refreshCaptcha();
  }, []);

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown(prevCount => prevCount - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [countdown]);

  const refreshCaptcha = async () => {
    try {
      const captchaData = await generateCaptcha();
      setCaptchaId(captchaData.captchaId);
      setCaptchaImage(`data:image/svg+xml;base64,${captchaData.captchaData}`);
    } catch (err) {
      console.error('Error generating captcha:', err);
      setMessage('Failed to load captcha. Please try again.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      const response = await forgotPassword({ email, captchaId, captchaValue });
      setMessage(response.data.message);
      setCountdown(60);
    } catch (error) {
      console.error(error);
      setMessage('An error occurred. Please try again.');
    } finally {
      setLoading(false);
      refreshCaptcha();
      setCaptchaValue('');
    }
  };

  const handleResend = () => {
    if (countdown === 0) {
      handleSubmit({ preventDefault: () => {} });
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h5">
          Forgot Password
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {captchaImage && (
            <Box sx={{ mt: 2, mb: 2 }}>
              <img src={captchaImage} alt="Captcha" />
              <Button onClick={refreshCaptcha} sx={{ ml: 2 }}>
                Refresh Captcha
              </Button>
            </Box>
          )}
          <TextField
            margin="normal"
            required
            fullWidth
            name="captcha"
            label="Captcha"
            id="captcha"
            value={captchaValue}
            onChange={(e) => setCaptchaValue(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading || countdown > 0}
          >
            {loading ? <CircularProgress size={24} /> : 
             countdown > 0 ? `Resend in ${countdown}s` : 'Reset Password'}
          </Button>
          {message && (
            <Typography color="info" align="center" sx={{ mb: 2 }}>
              {message}
            </Typography>
          )}
          {countdown === 0 && (
            <Typography align="center">
              Didn't receive the email?{' '}
              <Link component="button" variant="body2" onClick={handleResend}>
                Resend
              </Link>
            </Typography>
          )}
        </Box>
        {/* Login Link */}
        <Typography sx={{ mt: 2 }}>
          Remembered your password?{' '}
          <Link component={RouterLink} to="/login">
            Login here
          </Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default ForgotPassword;
